import { useQuery } from '@tanstack/react-query';

import queryKeys from '@/constants/queryKeys';
import { contentCreatorApplicationMeGet } from '@/services/api/requests/contentCreatorApplications';

const useContentCreatorApplicationMe = () =>
  useQuery({
    queryKey: [queryKeys.contentCreatorApplications.me],
    queryFn: contentCreatorApplicationMeGet,
  });

export default useContentCreatorApplicationMe;
